import { Center } from "@/components/standard/BFLayout"
import { H4 } from "@/components/standard/BFText"
import { Linking, Pressable } from "react-native"

export const ProgramDetailsButton = () => (
  <Pressable
    testID={"full-program-details-button"}
    onPress={() => {
      void Linking.openURL(`https://backflip.app.link/e/backfliprewards`)
    }}
  >
    <Center className={"m-5 my-10"}>
      <H4 className={"text-calm-blue underline"}>View Full Program Details</H4>
    </Center>
  </Pressable>
)
